import React, { ReactNode } from 'react';
import { CloseIcon } from './Icons';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  /** Custom footer content (e.g. Cancel + primary action). Defaults to a single Close button. */
  footer?: ReactNode;
}

export const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children, footer }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="fixed inset-0 bg-canvas-900/40 backdrop-blur-sm" onClick={onClose} />

        <div className="relative w-full max-w-lg animate-fade-up overflow-hidden rounded-3xl bg-white shadow-shell">
          <div className="flex items-start justify-between gap-4 px-6 pt-6">
            <h3 className="font-display text-lg font-semibold text-canvas-900">{title}</h3>
            <button
              onClick={onClose}
              className="rounded-xl p-1.5 text-canvas-500 transition-colors hover:bg-canvas-100 hover:text-canvas-900"
              aria-label="Close"
            >
              <CloseIcon width={18} height={18} />
            </button>
          </div>

          <div className="px-6 py-5">{children}</div>

          <div className="flex flex-row-reverse gap-2.5 border-t border-canvas-200 bg-canvas-50 px-6 py-4">
            {footer ?? (
              <button onClick={onClose} className="btn-secondary">
                Close
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
